<template>
    <v-card class="patient fill-height">
        <v-container>
            <v-form ref="studyForm" v-model="studyInfoValid" lazy-validation>

            <v-layout>
                <v-flex md10 offset-md1>
                    <h3 class="headline mb-4">Informations sur l'étude</h3>

                    <v-text-field v-model="name" :rules="nameRules" label="Nom de l'étude" required></v-text-field>
                    <v-menu
                        ref="showStartDatePicker"
                        v-model="showStartDatePicker"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="startAtFormatted"
                                label="Date de début"
                                append-icon="event"
                                v-on="on"
                                @blur="start_at = parseDate(startAtFormatted)"
                                required
                            ></v-text-field>
                        </template>
                        <v-date-picker ref="startAtPicker"
                                       locale="fr"
                                       v-model="start_at"
                                       no-title @input="showStartDatePicker = false"></v-date-picker>
                    </v-menu>
                    <v-menu
                        ref="showEndDatePicker"
                        v-model="showEndDatePicker"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="endAtFormatted"
                                label="Date de fin"
                                append-icon="event"
                                v-on="on"
                                @blur="end_at = parseDate(endAtFormatted)"
                                required
                            ></v-text-field>
                        </template>
                        <v-date-picker ref="endAtPicker"
                                       locale="fr"
                                       v-model="end_at"
                                       no-title @input="showEndDatePicker = false"></v-date-picker>
                    </v-menu>
                    <v-select
                        v-model="status"
                        :items="getStatusLabel"

                    ></v-select>

                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex md10 offset-md1 text-xs-right>
                    <v-btn :disabled="!studyInfoValid" color="success" @click="validate">Enregistrer
                    </v-btn>

                    <v-btn color="danger" flat @click="deleteDialog = true">
                        <v-icon>delete</v-icon> Supprimer
                    </v-btn>
                </v-flex>
            </v-layout>

        </v-form>

            <v-dialog v-model="deleteDialog" persistent max-width="480">
                <v-card>
                    <v-card-title class="headline">Supprimer l'étude</v-card-title>
                    <v-card-text>Voulez-vous vraiment supprimer l'étude ?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="deleteDialog = false">Annuler</v-btn>
                        <v-btn color="primary" text @click="deleteStudy()">Oui, supprimer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-container>
    </v-card>

</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'

    export default {
        name: "StudyForm",
        data() {
            return {
                mode: 'create',
                studyInfoValid: false,
                nameRules: [
                    v => !!v || 'Le nom est requis'
                ],
                showStartDatePicker: false,
                showEndDatePicker: false,
                deleteDialog: false,
                startAtFormatted: '',
                endAtFormatted: '',
            }
        },
        computed: {

            ...mapState('studies', {
                selectedStudyId: state => state.selectedStudy.id,
                studiesList: state => state.studiesList
            }),
            getStatusLabel() {
                return [
                    {
                        text: 'Brouillon',
                        value: 'draft'
                    },
                    {
                        text: 'Active',
                        value: 'active'
                    }
                ]
            },
            name: {
                get() {
                    return this.$store.state.studies.form.name
                },
                set(value) {
                    this.setName(value)
                }
            },
            status: {
                get() {
                    return this.$store.state.studies.form.status
                },
                set(value) {
                    this.setStatus(value)
                }
            },
            start_at: {
                get() {
                    return this.$store.state.studies.form.start_at
                },
                set(value) {
                    this.setStartAt(value)
                }
            },
            end_at: {
                get() {
                    return this.$store.state.studies.form.end_at
                },
                set(value) {
                    this.setEndAt(value)
                }
            },
        },
        created() {
            if (this.$route.params.id) {
                this.mode = "edit"

                this.setSelectedStudyId(this.$route.params.id)
                this.loadStudyForm()
            }
            else {
                this.mode = "create"
            }
        },
        mounted() {
            if (this.mode === 'create') {
                this.name = ''
                this.start_at = null
                this.end_at = null
            }
        },
        methods: {
            validate() {
                if (this.$refs.studyForm.validate()) {
                    this.submit()
                }
            },
            submit() {
                if (this.mode === 'create') {
                    this.createStudy().then(response => {
                        this.$router.replace({name: 'study.view', params: {id: response.data.study}})
                    }).catch(reason => {
                        //Stay here..
                    })
                } else {
                    this.updateStudy().then(response => {
                        this.$router.replace({name: 'study.view', params: {id: this.selectedStudyId}})
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            deleteStudy() {
                this.postDeleteStudy().then(response => {
                    this.$router.replace({name: 'studies'})
                }).catch(reason => {
                    //Stay here..
                })
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            ...mapMutations('studies', {
                setName: 'setFormName',
                setStatus: 'setFormStatus',
                setStartAt: 'setFormStartAt',
                setEndAt: 'setFormEndAt',
                setSelectedStudyId: 'setSelectedStudyId',

            }),
            ...mapActions('studies', ['createStudy', 'updateStudy', 'loadStudyForm', 'postDeleteStudy'])
        },
        watch: {
            start_at(date) {
                this.startAtFormatted = date ? this.$options.filters.formatedDate(date) : ''
            },
            end_at(date) {
                this.endAtFormatted = date ? this.$options.filters.formatedDate(date) : ''
            },
        },
    }
</script>

<style scoped>

</style>
